import { createContext, useState } from 'react';

export const ModalContext = createContext([(component: any) => {}, () => {}]);

const ModalProvider = (props: any) => {
    const [modal, setModal] = useState(null);
    const hideModal = () => {
        setModal(null);
    }
    const showModal = (component: any) => {
        setModal(component)
    }
    
    return (
        <ModalContext.Provider value={[showModal, hideModal]}>
            {modal}
            {props.children}
        </ModalContext.Provider>
    );
};

export default ModalProvider;
